import invalidateBoxQueries from 'admin/invalidateBoxQueries';
import { GetUserToken, useAuth } from 'components/AuthProvider';
import { UpdateAdminBoxMutationVariables } from 'generated/graphql';
import { GraphQLError } from 'graphql-request/dist/types';
import { getClientSdk } from 'graphql/client';
import { useSnackbar } from 'notistack';
import { MutationFunction, useMutation } from 'react-query';

const updateAdminBox = (
  getUserToken: GetUserToken
): MutationFunction<string, UpdateAdminBoxMutationVariables> => async (
  vars
) => {
  const token = await getUserToken();
  const data = await getClientSdk(token).UpdateAdminBox(vars);
  return data.update_box_by_pk?.imei ?? '';
};

const useUpdateAdminBox = (closeDialog: () => void) => {
  const { getUserToken } = useAuth();

  const { enqueueSnackbar } = useSnackbar();

  return useMutation<string, GraphQLError, UpdateAdminBoxMutationVariables>(
    updateAdminBox(getUserToken),
    {
      onSuccess: (imei) => {
        closeDialog();
        invalidateBoxQueries();
        enqueueSnackbar(`ボックス ${imei}が更新できました`, {
          variant: 'success',
          autoHideDuration: 5000,
        });
      },
      onError: (error, vars) => {
        enqueueSnackbar(`ボックス ${vars.box.imei} 更新　エラー`, {
          variant: 'error',
        });
      },
    }
  );
};

export default useUpdateAdminBox;
